export default __webpack_public_path__ + "static/media/no-url-found.0a1bfb21.svg";